// Promise-based, imperative replacement for window.confirm()/window.prompt().
// A single <DialogHost /> (mounted once near the app root) subscribes to
// requests dispatched here and renders the on-page modal; confirmDialog()/
// promptDialog() resolve once the person answers it.
let listener = null;

export const registerDialogListener = (fn) => {
  listener = fn;
};

export const confirmDialog = (message, options = {}) => new Promise((resolve) => {
  if (!listener) {
    resolve(window.confirm(message));
    return;
  }
  listener({
    type: 'confirm',
    message,
    confirmLabel: options.confirmLabel,
    cancelLabel: options.cancelLabel,
    tone: options.tone || 'default',
    resolve,
  });
});

export const promptDialog = (message, options = {}) => new Promise((resolve) => {
  if (!listener) {
    resolve(window.prompt(message, options.defaultValue || ''));
    return;
  }
  listener({
    type: 'prompt',
    message,
    defaultValue: options.defaultValue || '',
    optional: options.optional !== false,
    confirmLabel: options.confirmLabel,
    cancelLabel: options.cancelLabel,
    resolve,
  });
});
